import * as XLSX from 'xlsx';
export const getStatusColor = (
  status: string,
  type?:
    | 'status'
    | 'priority'
    | 'account'
    | 'trade'
    | 'verification'
    | 'payment'
    | 'kyc'
    | 'lead'
    | 'risk'
    | 'account-type'
    | 'tier'
): string => {
  const normalizedStatus = status?.toLowerCase();

  const colorMap: { [key: string]: string } = {
    active: 'bg-green-100 text-green-800',
    approved: 'bg-green-100 text-green-800',
    approve: 'bg-green-100 text-green-800',
    verified: 'bg-green-100 text-green-800',
    completed: 'bg-green-100 text-green-800',
    success: 'bg-green-100 text-green-800',
    enabled: 'bg-green-100 text-green-800',
    executed: 'bg-green-100 text-green-800',
    ready: 'bg-green-100 text-green-800',
    qualified: 'bg-green-100 text-green-800',
    converted: 'bg-emerald-100 text-emerald-800',
    resolved: 'bg-green-100 text-green-800',
    yes: 'bg-green-100 text-green-800',

    pending: 'bg-yellow-100 text-yellow-800',
    allocating: 'bg-yellow-100 text-yellow-800',
    generating: 'bg-yellow-100 text-yellow-800',
    inactive: 'bg-gray-100 text-gray-800',
    paused: 'bg-gray-100 text-gray-800',
    unverified: 'bg-orange-100 text-orange-800',
    contacted: 'bg-yellow-100 text-yellow-800',
    proposal: 'bg-purple-100 text-purple-800',
    processing: 'bg-blue-100 text-blue-800',
    'in-review': 'bg-blue-100 text-blue-800',
    'in-progress': 'bg-purple-100 text-purple-800',
    paid: 'bg-green-100 text-green-800',
    Paid: 'bg-green-100 text-green-800',

    rejected: 'bg-red-100 text-red-800',
    reject: 'bg-red-100 text-red-800',
    suspended: 'bg-red-100 text-red-800',
    disconnected: 'bg-red-100 text-red-800',
    critical: 'bg-red-100 text-red-800',
    expired: 'bg-red-100 text-red-800',
    failed: 'bg-red-100 text-red-800',
    disabled: 'bg-red-100 text-red-800',
    no: 'bg-red-100 text-red-800',

    new: 'bg-blue-100 text-blue-800',
    open: 'bg-blue-100 text-blue-800',
    closed: 'bg-gray-100 text-gray-800',
    rebate: 'bg-yellow-100 text-yellow-800',
    bonus: 'bg-green-100 text-green-800',

    urgent: 'bg-red-100 text-red-800 border-red-200',
    high: 'bg-orange-100 text-orange-800 border-orange-200',
    medium: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    low: 'bg-green-100 text-green-800 border-green-200',
    performance: 'bg-green-100 text-green-800 border-green-200',
    commission: 'bg-purple-100 text-purple-800 border-purple-200',
    revenue: 'bg-red-100 text-red-800 border-red-200',
    'trade-volume': 'bg-blue-100 text-blue-800 border-blue-200',
    standard: 'bg-blue-100 text-blue-800',
    premium: 'bg-purple-100 text-purple-800',
    vip: 'bg-amber-100 text-amber-800',
    live: 'bg-blue-100 text-blue-800',
    campaign: 'bg-purple-100 text-purple-800',
    demo: 'bg-purple-100 text-purple-800',
    'promo-banner': 'bg-green-100 text-green-800',
    'referral-link': 'bg-blue-100 text-blue-800',
    'utm-link': 'bg-pink-100 text-pink-800',

    buy: 'bg-green-100 text-green-800',
    sell: 'bg-red-100 text-red-800',

    'low-risk': 'bg-green-100 text-green-800',
    'medium-risk': 'bg-yellow-100 text-yellow-800',
    'high-risk': 'bg-red-100 text-red-800',

    refunded: 'bg-purple-100 text-purple-800',

    'bank-transfer': 'bg-blue-100 text-blue-800',
    'credit-card': 'bg-green-100 text-green-800',
    'debit-card': 'bg-emerald-100 text-emerald-800',
    cryptocurrency: 'bg-purple-100 text-purple-800',
    'internal-transfer': 'bg-orange-100 text-orange-800',
    internal: 'bg-orange-100 text-orange-800',
    atm: 'bg-red-100 text-red-800',
    upi: 'bg-indigo-100 text-indigo-800',
    credit: 'bg-purple-100 text-purple-800',
    debit: 'bg-green-100 text-green-800',
    withdrawal: 'bg-red-100 text-red-800',
    'net-banking': 'bg-teal-100 text-teal-800',
    'lot-based': 'bg-blue-100 text-blue-800',
    'revenue-share': 'bg-yellow-100 text-yellow-800',

    trading: 'bg-blue-100 text-blue-800',
    payment: 'bg-green-100 text-green-800',
    account: 'bg-purple-100 text-purple-800',
    technical: 'bg-orange-100 text-orange-800',
    general: 'bg-gray-100 text-gray-800',
  };

  if (
    type === 'trade' &&
    (normalizedStatus === 'buy' || normalizedStatus === 'sell')
  ) {
    return colorMap[normalizedStatus] || 'bg-gray-100 text-gray-800';
  }
  if (
    type === 'priority' &&
    ['urgent', 'high', 'medium', 'low'].includes(normalizedStatus)
  ) {
    return (
      colorMap[normalizedStatus] || 'bg-gray-100 text-gray-800 border-gray-200'
    );
  }
  if (type === 'lead') {
    const leadColorMap: { [key: string]: string } = {
      new: 'bg-blue-100 text-blue-800',
      contacted: 'bg-yellow-100 text-yellow-800',
      qualified: 'bg-green-100 text-green-800',
      proposal: 'bg-purple-100 text-purple-800',
      converted: 'bg-emerald-100 text-emerald-800',
    };
    return leadColorMap[normalizedStatus] || 'bg-gray-100 text-gray-800';
  }
  if (type === 'account-type') {
    const accountTypeColorMap: { [key: string]: string } = {
      Standard: 'bg-blue-100 text-blue-800',
      Premium: 'bg-purple-100 text-purple-800',
      VIP: 'bg-amber-100 text-amber-800',
      ECN: 'bg-indigo-100 text-indigo-800',
      standard: 'bg-blue-100 text-blue-800',
      premium: 'bg-purple-100 text-purple-800',
      vip: 'bg-amber-100 text-amber-800',
      ecn: 'bg-indigo-100 text-indigo-800',
      live: 'bg-blue-100 text-blue-800',
      demo: 'bg-purple-100 text-blue-800',
    };
    return (
      accountTypeColorMap[status] ||
      accountTypeColorMap[normalizedStatus] ||
      'bg-gray-100 text-gray-800'
    );
  }
  if (type === 'tier') {
    const tierColorMap: { [key: string]: string } = {
      Bronze: 'bg-amber-100 text-amber-800',
      Silver: 'bg-gray-100 text-gray-800',
      Gold: 'bg-yellow-100 text-yellow-800',
      Platinum: 'bg-purple-100 text-purple-800',
      bronze: 'bg-amber-100 text-amber-800',
      silver: 'bg-gray-100 text-gray-800',
      gold: 'bg-yellow-100 text-yellow-800',
      platinum: 'bg-purple-100 text-purple-800',
      'Master IB': 'bg-purple-200 text-purple-800',
      'Sub IB': 'bg-cyan-100 text-cyan-800',
    };
    return (
      tierColorMap[status] ||
      tierColorMap[normalizedStatus] ||
      'bg-gray-100 text-gray-800'
    );
  }

  return colorMap[normalizedStatus] || 'bg-gray-100 text-gray-800';
};

export const getAvailableActions = (status: string) => {
  const normalizedStatus = status.toLowerCase();
  switch (normalizedStatus) {
    case 'pending':
      return ['Approve', 'Reject'];
    case 'approve':
    case 'approved':
      return ['Reject'];
    case 'reject':
    case 'rejected':
      return ['Approve'];
    default:
      return ['Approve', 'Reject'];
  }
};

export const capitalizeFirst = (str: string): string => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const convertISOToDisplay = (apiDate: string | undefined): string => {
  if (!apiDate) return '';
  if (apiDate.includes('/') && apiDate.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
    const parts = apiDate.split('/');
    const firstNum = parseInt(parts[0], 10);
    if (firstNum > 12) {
      return apiDate;
    }
    return `${parts[1]}/${parts[0]}/${parts[2]}`;
  }
  const match = apiDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (match) {
    return `${match[3]}/${match[2]}/${match[1]}`;
  }
  return apiDate;
};

export const convertDisplayToISO = (
  displayDate: string | undefined
): string => {
  if (!displayDate) return '';
  if (displayDate.match(/^\d{4}-\d{2}-\d{2}$/)) return displayDate;
  const match = displayDate.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (match) {
    return `${match[3]}-${match[2]}-${match[1]}`;
  }
  return displayDate;
};

export const formatDateInput = (value: string): string => {
  let cleanValue = value.replace(/[^\d/]/g, '');
  if (cleanValue.length >= 2 && cleanValue.charAt(2) !== '/') {
    cleanValue = cleanValue.slice(0, 2) + '/' + cleanValue.slice(2);
  }
  if (cleanValue.length >= 5 && cleanValue.charAt(5) !== '/') {
    cleanValue = cleanValue.slice(0, 5) + '/' + cleanValue.slice(5);
  }
  if (cleanValue.length > 10) {
    cleanValue = cleanValue.slice(0, 10);
  }
  return cleanValue;
};

const getFieldValue = (row: Record<string, unknown>, key: string): unknown => {
  if (row[key] !== undefined) return row[key];
  const camel = key.charAt(0).toLowerCase() + key.slice(1);
  if (row[camel] !== undefined) return row[camel];
  const pascal = key.charAt(0).toUpperCase() + key.slice(1);
  if (row[pascal] !== undefined) return row[pascal];
  const lower = key.toLowerCase();
  if (row[lower] !== undefined) return row[lower];
  const upper = key.toUpperCase();
  if (row[upper] !== undefined) return row[upper];
  return undefined;
};

const toExportValue = (value: unknown): string | number => {
  if (value === undefined || value === null) return '-';
  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  ) {
    return String(value);
  }

  if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
    const obj = value as Record<string, unknown>;
    if ('val' in obj) return toExportValue(obj['val']);
  }
  return '-';
};

export const exportToExcel = (
  data: Record<string, unknown>[],
  headers: { key: string; label: string }[],
  fileName: string = 'export'
) => {
  if (!data || data.length === 0) {
    console.warn('[exportToExcel] No data to export');
    return;
  }

  const mappedData = data.map(row => {
    const mappedRow: Record<string, unknown> = {};
    headers.forEach(header => {
      const raw = getFieldValue(row, header.key);
      mappedRow[header.label] = toExportValue(raw);
    });
    return mappedRow;
  });

  const worksheet = XLSX.utils.json_to_sheet(mappedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export const exportTableToExcel = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any[],
  columns: Array<{
    id?: string;
    header: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    sortValue?: (row: any) => string | number;
  }>,
  fileName: string = 'export'
) => {
  if (!data || data.length === 0) {
    console.warn('[exportTableToExcel] No data to export');
    return;
  }

  const exportCols = columns.filter(col => col.id && col.id !== 'actions');

  const mappedData = data.map(row => {
    const mappedRow: Record<string, unknown> = {};
    exportCols.forEach(col => {
      const label = col.header as string;

      let value: unknown;
      if (col.sortValue) {
        value = col.sortValue(row);
      } else {
        value = getFieldValue(row as Record<string, unknown>, col.id!);
      }

      mappedRow[label] = toExportValue(value);
    });
    return mappedRow;
  });

  const worksheet = XLSX.utils.json_to_sheet(mappedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export const getImportanceColor = (importance: string) => {
  switch (importance) {
    case 'high':
      return 'bg-red-500 hover:bg-red-600';
    case 'medium':
      return 'bg-yellow-500 hover:bg-yellow-600';
    case 'low':
      return 'bg-green-500 hover:bg-green-600';
    default:
      return 'bg-gray-500';
  }
};

export const filterAccountsByType = (
  accounts: any[],
  accountType: 'demo' | 'live'
) => {
  return accounts.filter((account: any) => {
    if (account.type) {
      return account.type.toLowerCase() === accountType.toLowerCase();
    }
    const group = account.group?.toLowerCase() || '';
    return (
      group.startsWith(accountType.toLowerCase()) || group.startsWith('test')
    );
  });
};
